import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        if (!data.role || (!data.company && data.role === "vendor")) {
          navigate("/role", { replace: true, state: { user: data } });
        } else if (data.role === "vendor") {
          navigate("/vendor", { replace: true, state: { user: data } });
        } else {
          navigate("/dashboard", { replace: true, state: { user: data } });
        }
      } catch (e) {
        console.error("auth failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="font-mono-data text-xs tracking-[0.3em] uppercase text-text-secondary animate-pulse">
        Securing Session...
      </div>
    </div>
  );
}
